export const TENANT_DOMAIN_FUNCTIONS_RESET_STATE = 'TENANT_DOMAIN_FUNCTIONS_RESET_STATE';
export const TENANT_DOMAIN_FUNCTIONS_CURRENT_ITEM = 'TENANT_DOMAIN_FUNCTIONS_CURRENT_ITEM';

export const TENANT_DOMAIN_FUNCTIONS_REQUEST_LOADING = 'TENANT_DOMAIN_FUNCTIONS_REQUEST_LOADING';
export const TENANT_DOMAIN_FUNCTIONS_REQUEST_SUCCESS = 'TENANT_DOMAIN_FUNCTIONS_REQUEST_SUCCESS';
export const TENANT_DOMAIN_FUNCTIONS_REQUEST_FAILED = 'TENANT_DOMAIN_FUNCTIONS_REQUEST_FAILED';

export const TENANT_DOMAIN_FUNCTIONS_CURRENT_ACTION = 'TENANT_DOMAIN_FUNCTIONS_CURRENT_ACTION';
export const TENANT_DOMAIN_FUNCTIONS_RESET_ACTION = 'TENANT_DOMAIN_FUNCTIONS_RESET_ACTION';